<script>
  import { navigate } from 'svelte-routing';
  import { simplePopup } from '../components/simple-popup.svelte';
  import { Store, axios, forceFatch } from '../config.svelte';
  import TextInput from '../components/global/text-input.svelte';
  import PasswordInput from '../components/global/password-input.svelte';
  import Button from '../components/global/button.svelte';
  import AxiosClient from '../axios-client.js';
  import Base64 from '../base64.js';

  const axiosClient2 = AxiosClient.instance();
  const login = {
    email: {
      value: '',
      error: '',
    },
    pass: {
      value: '',
      error: '',
    },
  };

  if (Store && Store.get('loggedIn') && Store.get('loggedIn') === true) {
    goToDashboard();
  }
  async function submit() {
    if (login.email.value.replace(/ /g, '') === '') {
      login.email.error = 'Email input cannot be empty.';
      return;
    }
    login.email.error = '';
    if (login.pass.value.replace(/ /g, '') === '') {
      login.pass.error = 'Password input cannot be empty.';
      return;
    }
    login.pass.error = '';
    let result = await axiosClient2.send({
      url: '/auth/user',
      method: 'POST',
      headers: {
        Authorization:
          'Basic ' + Base64.encode(login.email.value + ':' + login.pass.value),
      },
    });
    if (result.success === false) {
      console.error(result.error);
      simplePopup.error(result.error.response.data.message);
      return;
    }
    Store.set('accessToken', result.response.data.accessToken);
    Store.set('refreshToken', result.response.data.refreshToken);
    goToDashboard();
  }
  async function goToDashboard() {
    let result = await axios.send({
      url: '/user/me',
      method: 'GET',
    });
    if (result.success === false) {
      console.error(result.error);
      return;
    }
    Store.set('user', result.response.data.user);
    Store.set('loggedIn', true);
    window.location = '/dashboard/overview';
  }
  async function checkAdmin() {
    const result = await axiosClient2.send({
      url: '/user/is-initialized',
      method: 'GET',
    });
    if (result.success === false) {
      console.error(result.error);
      simplePopup.error(result.error.response.data.message);
      return;
    }
    if (result.response.data.initialized === false) {
      navigate('/create-admin');
    }
  }
  checkAdmin();
</script>

<style type="text/scss">
  @import './login.scss';
</style>

<div class="wrapper">
  <div class="welcome">
    <div class="content">
      <div class="pre-title">Welcome to</div>
      <h1>
        Becomes
        <strong>CMS</strong>
      </h1>
    </div>
  </div>
  <div class="login">
    <h2>Log in</h2>
    <TextInput
      class="mt-50"
      invalid={login.email.error !== '' ? true : false}
      invalidText={login.email.error}
      labelText="Email"
      placeholder="- Email -"
      on:input={event => {
        if (event.eventPhase === 0) {
          login.email.value = event.detail;
        }
      }} />
    <PasswordInput
      class="mt-20"
      invalid={login.pass.error !== '' ? true : false}
      invalidText={login.pass.error}
      labelText="Password"
      placeholder="- Password -"
      on:input={event => {
        if (event.eventPhase === 0) {
          login.pass.value = event.detail;
        }
      }} />
    <div class="actions mt-50">
      <Button on:click={submit}>Log in</Button>
    </div>
  </div>
</div>
